(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/hooks/assets/javascripts/use-is-tipsinfo-supported.js') >= 0) return;  svs.modules.push('/components/tipsen/hooks/assets/javascripts/use-is-tipsinfo-supported.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const _React = React,
  useMemo = _React.useMemo,
  useContext = _React.useContext;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const selectTipsinfoSupport = svs.components.tipsen.engine.selectors.engineSelectors.selectTipsinfoSupport;
const RenderContext = svs.component.tipsen.renderContext.RenderContext;
const capitalizeFirstLetter = string => string.charAt(0).toUpperCase() + string.slice(1);

const useIsTipsinfoSupported = () => {
  const _useContext = useContext(RenderContext),
    pageType = _useContext.pageType;
  const tipsinfoSupport = useSelector(state => selectTipsinfoSupport(state, pageType));
  const shorthandVariables = useMemo(() => {
    const obj = {};
    for (const key in tipsinfoSupport) {
      if (tipsinfoSupport[key] !== undefined) {
        const keyName = "is".concat(capitalizeFirstLetter(key), "Supported");
        obj[keyName] = tipsinfoSupport[key];
      }
    }
    return obj;
  }, [tipsinfoSupport]);
  return _objectSpread({}, shorthandVariables);
};
setGlobal('svs.components.tipsen.hooks.useIsTipsinfoSupported', useIsTipsinfoSupported);

 })(window);